import React from 'react';
import { Grid, NumberInput, Textarea, TextInput, Title } from '@mantine/core';
import type { ICotizacionPostventa } from '../../../../modelos/CotizadorPostventa/entidades/ICotizacionPostventa';
import type { CampoCotizacionPostventa } from '../../interfaces';

interface PasoDatosGeneralesVistaProps {
    cotizacion: ICotizacionPostventa;
    errores: Record<string, string>;
    alCambiar: (campo: CampoCotizacionPostventa, valor: string | number) => void;
}

/** Paso 1: proyecto, cliente, unidades y descripción del trabajo. */
export const PasoDatosGeneralesVista: React.FC<PasoDatosGeneralesVistaProps> = ({ cotizacion, errores, alCambiar }) => (
    <Grid>
        <Grid.Col span={12}>
            <Title order={5} mb="xs">Información del Proyecto</Title>
        </Grid.Col>
        <Grid.Col span={{ base: 12, md: 4 }}>
            <TextInput size="xs" withAsterisk label="Proyecto" maxLength={100} value={cotizacion.Proyecto} onChange={(e) => alCambiar('Proyecto', e.currentTarget.value)} error={errores.Proyecto} />
        </Grid.Col>
        <Grid.Col span={{ base: 12, md: 4 }}>
            <TextInput size="xs" withAsterisk label="Cliente" maxLength={100} value={cotizacion.Cliente} onChange={(e) => alCambiar('Cliente', e.currentTarget.value)} error={errores.Cliente} />
        </Grid.Col>
        <Grid.Col span={{ base: 12, md: 4 }}>
            <NumberInput
                size="xs" withAsterisk label="Número de unidades" description="Equipos o trabajos idénticos"
                min={1} allowNegative={false} allowDecimal={false} hideControls
                value={cotizacion.NumeroUnidades}
                onChange={(v) => alCambiar('NumeroUnidades', v === '' ? '' : Number(v))}
                error={errores.NumeroUnidades}
            />
        </Grid.Col>
        <Grid.Col span={12}>
            <Textarea
                size="xs" withAsterisk label="Descripción del trabajo realizado o a realizar"
                placeholder="Ej.: Cambio de cables de tracción"
                autosize minRows={3} maxRows={6} maxLength={1000}
                value={cotizacion.Descripcion}
                onChange={(e) => alCambiar('Descripcion', e.currentTarget.value)}
                error={errores.Descripcion}
            />
        </Grid.Col>
    </Grid>
);
